module.exports = __webpack_public_path__ + "img/61039ee2311cf1.60960107.5c9bfd32.png";